import React from 'react';
import PropTypes from 'prop-types';

import './ButtonsStyleItem.css';


const ButtonsStyleItem = ({ active, onClick, buttonType }) => (
  <div
    className={`buttons-style-item__component${active ? ' active': ''}`}
    onClick={onClick}
    role="button"
    tabIndex={-1}
  >
    <div className={`button-wrapper ${buttonType}`} />
  </div>
);

ButtonsStyleItem.propTypes = {
  onClick: PropTypes.func.isRequired,
  buttonType: PropTypes.string.isRequired,
  active: PropTypes.bool,
};

ButtonsStyleItem.defaultProps = {
  active: null,
};

export default ButtonsStyleItem;
